export type ListingSearchScope = 'all' | 'shop' | 'property' | 'classifieds' | 'vendors';

import { MARKETPLACE, pathUnder } from '@/lib/marketplacePaths';

export const LISTING_SEARCH_SCOPES: {
  id: ListingSearchScope;
  label: string;
  path: string;
  placeholder: string;
}[] = [
  { id: 'all', label: 'All', path: '/search/', placeholder: 'Search ShopGND…' },
  { id: 'shop', label: 'Shop', path: MARKETPLACE.shop, placeholder: 'Search products…' },
  { id: 'property', label: 'Properties', path: MARKETPLACE.realEstate, placeholder: 'Search properties…' },
  { id: 'classifieds', label: 'Classifieds', path: MARKETPLACE.classifieds, placeholder: 'Search classifieds…' },
  { id: 'vendors', label: 'Businesses', path: MARKETPLACE.vendors, placeholder: 'Search businesses…' },
];

export function listingSearchScopesForFlags(flags: {
  propertyListings: boolean;
  classifieds: boolean;
  businessDirectory: boolean;
}): typeof LISTING_SEARCH_SCOPES {
  return LISTING_SEARCH_SCOPES.filter((s) => {
    if (s.id === 'property') return flags.propertyListings;
    if (s.id === 'classifieds') return flags.classifieds;
    if (s.id === 'vendors') return flags.businessDirectory;
    return true;
  });
}

export function listingScopeFromPathname(pathname: string): ListingSearchScope {
  if (pathUnder(pathname, '/search')) return 'all';
  if (pathUnder(pathname, MARKETPLACE.realEstate)) return 'property';
  if (pathUnder(pathname, MARKETPLACE.classifieds)) return 'classifieds';
  if (pathUnder(pathname, MARKETPLACE.vendors)) return 'vendors';
  if (pathUnder(pathname, MARKETPLACE.shop)) return 'shop';
  return 'all';
}

export function buildScopedSearchUrl(
  scope: ListingSearchScope,
  query: string,
  extra?: { category?: string; sector?: string },
): string {
  const def = LISTING_SEARCH_SCOPES.find((s) => s.id === scope)!;
  const params = new URLSearchParams();
  const q = query.trim();
  if (q) params.set('q', q);
  if (scope === 'shop' && extra?.category) params.set('category', extra.category);
  if (scope === 'vendors') {
    params.set('sector', extra?.sector ?? 'shop');
  }
  const qs = params.toString();
  return qs ? `${def.path}?${qs}` : def.path;
}

export const LISTING_HERO_ACCENTS = {
  property: 'from-[#1a5c3a] via-brand-800 to-slate-900',
  classifieds: 'from-brand-900 via-[#174a36] to-slate-950',
  vendors: 'from-[#5c4a1a] via-[#7a6230] to-slate-900',
  shop: 'from-brand-800 via-brand-900 to-slate-950',
  all: 'from-brand-800 via-brand-900 to-slate-950',
} as const;
